/**
 * Save term validation schema
 */

import { z } from "zod";

/**
 * Schema for saving a term (create or update)
 */
export const saveTermArgsSchema = z.object({
  id: z.number().nullable(),
  title: z.string().min(1, "Título é obrigatório"),
  content: z.string().min(1, "Conteúdo é obrigatório"),
  active: z.boolean(),
  company: z.object({
    id: z.number().positive("ID da empresa deve ser positivo")
  })
});
